import apiClient from 'hub-http/clients/apiClient';
import BrandingRecord from 'documents-lib/js/records/BrandingRecord';
import { ACCOUNT_BRAND_ID } from '../constants/BrandConstants';
export const fetchBrand = businessUnitId => apiClient.get(`business-units/v1/business-units/${businessUnitId}`);
export const fetchBrandColors = businessUnitId => apiClient.get('branding/v1/colors/brand-kit', {
  query: {
    businessUnitId
  }
});
export const fetchBrandLogos = businessUnitId => apiClient.get('branding/v1/logos/brand-kit', {
  query: {
    businessUnitId
  }
});
export const fetchAccountBranding = () => apiClient.get('branding/v1/branding/public');
export const fetchBrandingForBrandId = async brandId => {
  const businessUnitId = brandId !== null && brandId !== void 0 ? brandId : ACCOUNT_BRAND_ID;
  try {
    var _primaryLogo$logoUrl, _primaryLogo$logoAltT, _brand$name, _primaryColor$color, _secondaryColor$color, _accountBranding$show;
    const [brand, colors, logos, accountBranding] = await Promise.all([fetchBrand(businessUnitId).catch(() => null), fetchBrandColors(businessUnitId), fetchBrandLogos(businessUnitId), fetchAccountBranding()]);
    const primaryColor = colors.find(c => c.colorType === 'PRIMARY');
    const secondaryColor = colors.find(c => c.colorType === 'SECONDARY');
    const primaryLogo = logos.find(l => l.primaryLogo);
    return new BrandingRecord({
      logoUrl: (_primaryLogo$logoUrl = primaryLogo === null || primaryLogo === void 0 ? void 0 : primaryLogo.logoUrl) !== null && _primaryLogo$logoUrl !== void 0 ? _primaryLogo$logoUrl : null,
      logoAltText: (_primaryLogo$logoAltT = primaryLogo === null || primaryLogo === void 0 ? void 0 : primaryLogo.logoAltText) !== null && _primaryLogo$logoAltT !== void 0 ? _primaryLogo$logoAltT : null,
      companyName: (_brand$name = brand === null || brand === void 0 ? void 0 : brand.name) !== null && _brand$name !== void 0 ? _brand$name : null,
      primaryColor: (_primaryColor$color = primaryColor === null || primaryColor === void 0 ? void 0 : primaryColor.color) !== null && _primaryColor$color !== void 0 ? _primaryColor$color : null,
      secondaryColor: (_secondaryColor$color = secondaryColor === null || secondaryColor === void 0 ? void 0 : secondaryColor.color) !== null && _secondaryColor$color !== void 0 ? _secondaryColor$color : null,
      showSalesAd: (_accountBranding$show = accountBranding === null || accountBranding === void 0 ? void 0 : accountBranding.showSalesAd) !== null && _accountBranding$show !== void 0 ? _accountBranding$show : false
    });
  } catch (_unused) {
    return new BrandingRecord();
  }
};